<template>
  <div class="main-container">
    <div>
      <!-- <div class="isShowLoading" color="#aab" v-if="isShowLoading">
        <van-loading vertical type="spinner" />
        <van-overlay :show="isShowLoading" />
      </div> -->
      <div v-if="showEmpty">
        <div v-for="item in pageData"
             :key="item.fitUpModuleId">
          <div v-if="item.moduleType == 'banner'">
            <van-swipe indicator-color="#fff"
                       :loop="true"
                       :autoplay="3000">
              <van-swipe-item loop
                              v-for="image in item.bannerModuleItems"
                              :key="image.id"
                              v-lazy="image"
                              @click="onSwiperClick(image.id)">
                <div>
                  <van-image width="100%"
                             fit="contain"
                             :src="image.imageUrl"></van-image>
                </div>
              </van-swipe-item>
            </van-swipe>
          </div>
          <div v-if="item.moduleType == 'package'">
            <van-cell @click="showPopup">
              <div>
                <van-image :src="item.pictureUrl" />
              </div>
            </van-cell>
            <van-popup v-model="show"
                       class="pagePopup">
              <van-grid :column-num="1"
                        v-for="good in item.packageItemModules"
                        :key="good.goodsId"
                        style="background: #fff">
                <!-- <div style="padding-top:2vh;">{{good.goodsName}}</div> -->
                <div>
                  <div class="pagepackageModule">
                    <van-grid-item v-for="sku in good.packageItemModuleSkus"
                                   :key="sku.skuId">
                      <van-card :num="sku.quantity"
                                :price="sku.unitPrice / 100"
                                :desc="sku.specificationNames"
                                :title="good.goodsName"
                                :thumb="sku.pictureUrl"
                                class="card_shop"></van-card>
                    </van-grid-item>
                  </div>
                </div>
                <!-- <div class="packageNum">
                本产品在一口价中最少购买
                <span style="color: #b80014;">{{good.minQuantity}}</span>件最多购买
                <span style="color: #b80014;">{{good.maxQuantity}}</span>件
              </div>-->
              </van-grid>
              <van-grid clickable
                        :column-num="2">
                <van-grid-item text="取消"
                               @click="cancel"
                               class="cancel" />
                <van-grid-item text="立即购买"
                               @click="clickUrlCart(item.packageId)"
                               class="buy" />
              </van-grid>
            </van-popup>
          </div>

          <div v-if="item.moduleType == 'goods'"
               :id="'id' + item.moduleType">
            <van-grid :column-num="2"
                      gutter="3vw"
                      class="goods-grid">
              <van-grid-item @click="onGoodsClick(goods)"
                             v-for="goods in item.goodsModuleItems"
                             :key="goods.goodsCode"
                             style="width: 100%; padding-top: 3vw">
                <div class="image">
                  <van-image :src="goods.goodsImageUrl" />
                </div>
                <div class="grid_bottom"
                     style="width: 100%">
                  <div class="text">
                    <div class="goodsName">{{ goods.goodsName }}</div>
                    <div class="price">￥{{ goods.goodsPrice }}</div>
                  </div>
                </div>
              </van-grid-item>
            </van-grid>
          </div>
          <div v-if="item.moduleType == 'richtext'"
               :id="'id' + item.moduleType">
            <div v-html="item.textContent"></div>
          </div>
          <div v-if="item.moduleType == 'imagenav'"
               class="image-nav">
            <van-grid :column-num="item.navList.length"
                      :border="false"
                      :clickable="true"
                      icon-size="47px">
              <van-grid-item v-for="(item, index) in item.navList"
                             :class="{ isActive: index === navgatorIndex }"
                             :icon="item.imageUrl"
                             :key="item.id"
                             :text="item.title"
                             @click="onImageNavClick(item.linkTypeId, item.link_Id)"></van-grid-item>
            </van-grid>
          </div>
          <div v-if="item.moduleType == 'labnav'"
               :id="'id' + item.moduleType">
            <van-cell-group>
              <van-cell :title="item.title"
                        :is-link="item.isShowMore"
                        :value="item.isShowMore == true ? '更多' : ''" />
            </van-cell-group>
          </div>
          <div :id="'id' + item.moduleType"
               v-if="item.moduleType == 'picture'"
               :style="{
              margin:
                item.topMargin + 'px ' + 'auto ' + item.bottomMargin + 'px ',
              display: 'flex'
            }">
            <div :style="{ width: item.width + 'vw ' }"></div>
            <van-image :src="item.pictureUrl"
                       lazy-load
                       style="background: transparent; flex: 1"
                       @click="onPictureClick(item)" />
            <div :style="{ width: item.width + 'vw ' }"></div>
          </div>
          <div :id="'id' + item.moduleType"
               v-if="item.moduleType == 'title'"
               :style="{
              margin:
                item.topMargin + 'px ' + 'auto ' + item.bottomMargin + 'px ',
              display: 'flex'
            }">
            <div :style="{ width: item.width + 'vw ' }"></div>
            <van-image :src="item.pictureUrl"
                       lazy-load
                       style="background: transparent; flex: 1"
                       @click="onPictureClick(item)" />
            <div :style="{ width: item.width + 'vw ' }"></div>
          </div>
        </div>
      </div>

      <div v-else
           class="index-empty">
        <van-empty description="店家正在努力上新中~" />
      </div>
    </div>
    <van-overlay :show="isLoading">
      <div class="wrapper">
        <loading v-if="isLoading == true"></loading>
      </div>
    </van-overlay>
  </div>
</template>
<script>
import {
  Swipe,
  SwipeItem,
  Grid,
  GridItem,
  Card,
  Icon,
  Panel,
  Image,
  Cell,
  Popup,
  Button,
  Col,
  Row,
  Dialog,
  Loading,
  Overlay,
  Empty,
  Lazyload
} from "vant";
import service from "../../api/miniPage/index";
import loading from "../../components/loading/loading";
export default {
  components: {
    [Swipe.name]: Swipe,
    [SwipeItem.name]: SwipeItem,
    [Grid.name]: Grid,
    [GridItem.name]: GridItem,
    [Card.name]: Card,
    [Icon.name]: Icon,
    [Panel.name]: Panel,
    [Image.name]: Image,
    [Icon.name]: Icon,
    [Cell.name]: Cell,
    [Popup.name]: Popup,
    [Button.name]: Button,
    [Col.name]: Col,
    [Row.name]: Row,
    [Dialog.name]: Dialog,
    [Loading.name]: Loading,
    [Overlay.name]: Overlay,
    [Empty.name]: Empty,
    [Lazyload.name]: Lazyload,
    loading
  },
  data () {
    return {
      imageUrl: "value",
      showEmpty: false,
      isLoading: true, //loading状态
    };
  },
  mounted () {
    this.init(this.$route.query.code);
  },
  methods: {
    init (code) {
      service.get(code).then((res) => {
        if (res.statusCode == 200) {
          if (res.statusCode == 200 && res.data == "") {
            this.showEmpty = false;
          } else {
            this.showEmpty = true;
          }
          this.pageData = JSON.parse(res.data.htmlJson);
          console.log(JSON.parse(res.data.htmlJson))
          setTimeout(() => {
            this.isLoading = false;
          }, 1800);
        }
      });
    }
  }
};
</script>